window.onload = function(e){

  // check load
  let themeID = window?.Shopify?.theme?.id;    // Ensure this gets the correct themeID
  let editedCssTheme = window?.flitsRewardPageObjects?.Metafields?.[`FLITS_REWARD_PAGE_CSS_CUSTOMIZED_URL_${themeID}`];
  let editedJsTheme = window?.flitsRewardPageObjects?.Metafields?.[`FLITS_REWARD_PAGE_JS_CUSTOMIZED_URL_${themeID}`];
  let editedCss = window?.flitsRewardPageObjects?.Metafields?.FLITS_REWARD_PAGE_CSS_CUSTOMIZED_URL;
  let editedJs = window?.flitsRewardPageObjects?.Metafields?.FLITS_REWARD_PAGE_JS_CUSTOMIZED_URL;
  let dcss = document.getElementById('flitsRewardPageDefaultCss');
  let djs = document.getElementById('flitsRewardPageDefaultJs');
  if(editedCssTheme){
    loadStyleScript(editedCssTheme).then(() => {
    if(dcss) dcss.remove()
    }).catch(() => {});
  }
  else if(editedCss){
    loadStyleScript(editedCss).then(() => {
      if(dcss) dcss.remove()
    }).catch(() => {});
  }
  if(editedJsTheme){
    loadStyleScript(editedJsTheme).then(() => {
      // if(djs) djs.remove()
      return;
    }).catch(() => {});
  }else if(editedJs){
    loadStyleScript(editedJs).then(() => {
      // if(djs) djs.remove()
      return;
    }).catch(() => {});
  }

  //global var
  let creditRules;
  let lanjson;
  let referInvitationText;
  let customerReferLink;
  let lanjsonAdmin =  window.flitsRewardPageObjects?.Metafields?.FLITS_EXTENSION_ON_SITE_CONTENT_custom_reward_page;
  let themeLang;

  // check enable or disbale
  if(!lanjsonAdmin?.is_enable){
    document.querySelector('.flits-reward-page-main').remove();
    return;
  }
  if(!lanjsonAdmin?.how_it_works?.is_enable){
    let howItWorksDom = document.querySelector(".flits-reward-page-how-it");
    if(howItWorksDom) howItWorksDom.style.display = "none";
  }
  if(!lanjsonAdmin?.how_to_earn?.is_enable){
    let howToEarnDom = document.querySelector(".flits-reward-page-ways-to-earn");
    if(howToEarnDom) howToEarnDom.style.display = "none";
  }
  if(!lanjsonAdmin?.how_to_redeem?.is_enable){
    let howToRedeemDom = document.querySelector(".flits-reward-page-ways-to-redeem");
    if(howToRedeemDom) howToRedeemDom.style.display = "none";
  }
  if(!lanjsonAdmin?.refer_friend?.is_enable){
    let referFriendDom = document.querySelector(".flits-reward-page-refer-friend");
    if(referFriendDom) referFriendDom.style.display = "none";
  }
  
  // get language object
  async function getLanuageTemp() {
    let lanUrl = 'https://cdn.shopify.com/s/files/1/0631/7647/4823/files/reward_page_local.json?v=1727276985';
    let lanCall = await fetch(lanUrl);
    if (lanCall.ok) {
      lang = await lanCall.json();
      return lang;
    }
  }
  async function getLanuage() {
    let shopLocal = window?.Shopify?.locale || document.getElementsByTagName("html")[0].getAttribute("lang") || document.documentElement.lang;
    let langEditedUrl = window?.flitsRewardPageObjects?.Metafields?.[`MULTILANGUAGE_CONTENT_en_${themeID}`];
    let defaultLangUrl = window?.flitsRewardPageObjects?.Metafields?.[`MULTILANGUAGE_CONTENT_en_-1`];
    if(shopLocal && langEditedUrl && shopLocal !== '' ){
      try {
        return langEditedUrl;
        
      } catch (error) {
        if(defaultLangUrl){
          return defaultLangUrl;
        }
        else{
          let lanCallDefault = await fetch(`https://cdn.shopify.com/s/files/1/0030/7491/6461/files/en_json_with_new_customer_account_page.json`);
          let lanCallDefaultJson = await lanCallDefault.json();
          return lanCallDefaultJson;
        }
      }
    }
    else{
      if(defaultLangUrl){
        return defaultLangUrl;
      }
      else{
        let lanCallDefault = await fetch(`https://cdn.shopify.com/s/files/1/0030/7491/6461/files/en_json_with_new_customer_account_page.json`);
        let lanCallDefaultJson = await lanCallDefault.json();
        return lanCallDefaultJson
      }
    }
  }
  getLanuageTemp().then(
    function(value) {
      lanjson = value;
      getLanuage().then(
        function(value) {
          themeLang = value;
          callRules();
          commonLangUpdate();
          let primaryColor = lanjsonAdmin?.primary_color || '#fff'; // Change this to your primary color
          let primaryTextColor = getContrastingColor(primaryColor);
          if(primaryColor && primaryTextColor){
            document.documentElement.style.setProperty("--flitsrewardpagePrimaryButtonBg", primaryColor);
            document.documentElement.style.setProperty("--flitsrewardpagePrimaryButtonText", primaryTextColor);
          }
        }
      );
    }
  );

  // get refer link of the customer
  async function getReferralLink() {
    let flits_referral_link;
    let customer_name = window.flitsRewardPageObjects.customerName;
    let customer_ref_code = window.flitsRewardPageObjects.customerId != -1 ? parseInt(window.flitsRewardPageObjects.customerId).toString(36) : "";
    if (customer_ref_code){
      flits_referral_link = "https://" + window.location.host + "/account/register?flits_refer_code=" + encodeURIComponent(unescape(btoa(customer_ref_code))) + "&flits_inviter_name=" + encodeURIComponent(unescape(btoa(customer_name)));
    }
    return flits_referral_link;
  }
  
  // get rules from flits api
  async function getRules() {
    try{
        let formdata = new FormData();
        formdata.append("token", window.flitsRewardPageObjects.token);
        formdata.append("customer_hash", window.flitsRewardPageObjects.customerHash);
        let requestOptions = {
            method: 'POST',
            redirect: 'follow',
            body: formdata
        };
        let result = await fetch(`${window.location.origin}${window.flitsRewardPageObjects?.base_url}/${window.flitsRewardPageObjects.customerId}/get_rule`, requestOptions)
        let resultJson = await result.json();
        return resultJson;
      }catch (error) {
        return window.flitsRewardPageObjects?.Metafields?.GET_RULES_FOR_GUEST_CUSTOMERS;
      }
  }
  
  // get credit from flits api
  async function getCredit() {
    try{
        let requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
        let result = await fetch(`${window.location.origin}${window.flitsRewardPageObjects?.base_url}/${window.flitsRewardPageObjects.customerId}/credit/get_credit?token=${window.flitsRewardPageObjects.token}&customer_hash=${window.flitsRewardPageObjects.customerHash}`, requestOptions)
        let resultJson = await result.json();
        return resultJson;
      }catch (error) {
        return null;
      }
  }

  // call rule and credit api
  function callRules(){
    if(window.flitsRewardPageObjects?.customer){
      getRules().then(
        function(value) {
          creditRules = value;
          processEarningRules();
          processSpentRules();
          subscriberEarnClickDispatch();
          // dispatch event for Customer Rules
          let customerRules = new CustomEvent("flitsRewardPageCustomerRules", {
            detail: {
              data: value
            }
          });
          window.dispatchEvent(customerRules);
        }
      );
      getCredit().then(
        function(value){
          let credit = value.customer.credits;
          let bannerInfo = document.querySelector('.flits-reward-page-hero-banner .flits-reward-page-sub-header');
          if(bannerInfo){
            bannerInfo.innerHTML = lanjsonAdmin.banner.member_description.replace("{{ credit }}", MoneyFormat(credit/100));
          }
          window.flitsRewardAcceptMarketing = value?.customer?.accepts_marketing;
          hideLoader();
          // dispatch event for pageLoaded
          let loaded = new CustomEvent("flitsRewardPageLoaded", {});
          // dispatch event for credit api response
          let creditResponse = new CustomEvent("flitsRewardPageCreditResponse", {
            detail: {
              data: value
            }
          });
          window.dispatchEvent(loaded);
          window.dispatchEvent(creditResponse);
        }
      )
      if(window.flitsRewardPageObjects.scReferOn){
        getReferralLink().then(
          function(value) {
            customerReferLink = value;
            let referLinkInput = document.querySelector(".flits-reward-page-link-copy-btn-main input[name='flits_reward_page_referral_link']");
            if(referLinkInput){
              referLinkInput.value = value;
              referLinkInput.setAttribute('readonly', true);
              referInvitationText = themeLang?.flits?.refer_friend_page?.referral_program_invitation_message.replace('{{ shop_name }}', window.flitsRewardPageObjects.shopName).replace('{{ link }}', value);
              let testData = {
                  title: 'Refer Freind',
                  text: referInvitationText
              };
              let navigatorDom = document.querySelector('.flits-reward-page-navigator-share-btn');
              if (navigator.share && navigator.canShare(testData)) {} else {
                  if(navigatorDom){
                    navigatorDom.remove();
                  }
              }
            }
          }
        );
      }
      else{
        let referSectionDom = document.querySelector("section.flits-reward-page-refer-friend");
        if(referSectionDom){
          referSectionDom.remove();
        }
      }
    }
    else{
      creditRules = window.flitsRewardPageObjects?.Metafields?.GET_RULES_FOR_GUEST_CUSTOMERS;
      processEarningRules();
      processSpentRules();
      hideLoader();
      if(!window.flitsRewardPageObjects.scReferOn){
        let referSectionDom = document.querySelector("section.flits-reward-page-refer-friend");
        if(referSectionDom){
          referSectionDom.remove();
        }
      }
      // dispatch event for pageLoaded
      event = new CustomEvent("flitsRewardPageLoaded", {});
      window.dispatchEvent(event);
    }
  }
  
  // setup earning rules
  function getEarnRuleData(rule){
    const { module_on, title, description, credits, column_value, is_fixed, relation, avails, is_earned } = rule;
    switch (module_on) {
        case 'register':
            return {
                title: themeLang?.flits?.how_to_earn_credit_page.register_credit_rule_title,
                description: themeLang?.flits?.how_to_earn_credit_page.register_credit_rule_description.replace('{{ credit }}', MoneyFormat(credits/100)),
                icon: lanjson?.flits.icons.signup_icon,
                linkTo: '/account/register',
                linkBtntext: themeLang?.flits?.how_to_earn_credit_page.register_link_btn_text,
                isEarned: (window.flitsRewardPageObjects.customer) ? true : is_earned,
                moduleOn: module_on
            };
        case 'subscribe':
            return {
                title: themeLang?.flits?.how_to_earn_credit_page.subscribe_credit_rule_title,
                description: themeLang?.flits?.how_to_earn_credit_page.subscribe_credit_rule_description.replace('{{ credit }}', MoneyFormat(credits/100)),
                icon: lanjson?.flits.icons.subscriber_icon,
                linkTo: '/account#howToEarn',
                linkBtntext: themeLang?.flits?.how_to_earn_credit_page.subscribe_link_btn_text,
                isEarned: (window.flitsRewardPageObjects.customer) ? window.flitsRewardAcceptMarketing : is_earned,
                moduleOn: module_on
            };
        case 'order_number':
            if(relation == '>='){
                return {
                    title: themeLang?.flits?.how_to_earn_credit_page.specific_order_and_next_orders_credit_rule_title.replace('{{ order_count }}', column_value),
                    description: themeLang?.flits?.how_to_earn_credit_page.specific_order_and_next_orders_credit_rule_description.replace('{{ credit }}', (is_fixed) ?  MoneyFormat(credits/100) : `${credits/100}%`).replace('{{ order_count }}', column_value).replace('{{ order_count+1 }}', parseInt(column_value) + 1).replace('{{ order_count+2 }}', parseInt(column_value) + 2).replace('{{ order_count+n }}', 'n'),
                    icon: lanjson?.flits.icons.place_order_icon,
                    linkTo: '/collections/all',
                    linkBtntext: themeLang?.flits?.how_to_earn_credit_page.order_number_link_btn_text,
                    isEarned: false,
                    moduleOn: module_on
                }
            }
            else{
                return {
                    title: themeLang?.flits?.how_to_earn_credit_page.specific_order_credit_rule_title,
                    description: themeLang?.flits?.how_to_earn_credit_page.specific_order_credit_rule_description.replace('{{ credit }}', (is_fixed) ?  MoneyFormat(credits/100) : `${credits/100}%`).replace('{{ order_count }}', column_value),
                    icon: lanjson?.flits.icons.place_order_icon,
                    linkTo: '/collections/all',
                    linkBtntext: themeLang?.flits?.how_to_earn_credit_page.order_number_link_btn_text,
                    isEarned: is_earned,
                    moduleOn: module_on
                }
            };
        case 'birthdate':
            let birthDescription = themeLang?.flits?.how_to_earn_credit_page.birthdate_credit_rule_description_1.replace('{{ credit }}', MoneyFormat(credits/100));
            let termconditionDescription = themeLang?.flits?.how_to_earn_credit_page.birthdate_credit_rule_description_3;
            return {
                title: themeLang?.flits?.how_to_earn_credit_page.birthdate_credit_rule_title,
                description: `<span>${birthDescription}</span><span class="flits-reward-birth-terms">${termconditionDescription}</span>`,
                icon: lanjson?.flits.icons.birthday_icon,
                linkTo: "/account#profile",
                linkBtntext: themeLang?.flits?.how_to_earn_credit_page.birthday_link_btn_text,
                isEarned: false,
                moduleOn: module_on
            }
        case 'monthly_date':
            if(is_fixed) {
                return {
                    title: themeLang?.flits?.how_to_earn_credit_page.special_day_credit_rule_title,
                    description: themeLang?.flits?.how_to_earn_credit_page.special_day_credit_rule_description.replace('{{ credit }}',  MoneyFormat(credits/100)).replace('{{ date }}', new Date(column_value).getDate() + '/' + (new Date(column_value).getMonth() + 1) + '/' + new Date(column_value).getFullYear()),
                    icon: lanjson?.flits.icons.birthday_icon,
                    linkTo: "none",
                    linkBtntext: themeLang?.flits?.how_to_earn_credit_page.monthly_date_btn_text,
                    isEarned: is_earned,
                    moduleOn: module_on
                }
            }
            else{
                return {
                    title: themeLang?.flits?.how_to_earn_credit_page.monthly_credit_rule_title,
                    description: themeLang?.flits?.how_to_earn_credit_page.monthly_credit_rule_description.replace('{{ credit }}',  MoneyFormat(credits/100)).replace('{{ date }}', new Date(column_value).getDate()),
                    icon: lanjson?.flits.icons.birthday_icon,
                    linkTo: "none",
                    linkBtntext: themeLang?.flits?.how_to_earn_credit_page.monthly_date_btn_text,
                    isEarned: false,
                    moduleOn: module_on
                }
            }
        case 'product_review':
            return {
                title: themeLang?.flits?.how_to_earn_credit_page.product_review_credit_rule_title,
                description: themeLang?.flits?.how_to_earn_credit_page.product_review_credit_rule_description.replace('{{ credit }}',  MoneyFormat(credits/100)),
                icon: lanjson?.flits.icons.review_icon,
                linkTo: '/collections/all',
                linkBtntext: themeLang?.flits?.how_to_earn_credit_page.product_review_btn_text,
                isEarned: false,
                moduleOn: module_on
            }
        case 'product_tag':
            let productTagSpan = document.createElement('span');
            avails.forEach((item, index) => {
                let productTagAnchor = document.createElement('a');
                productTagAnchor.setAttribute('href', '/search?q=' + item);
                productTagAnchor.setAttribute('target', '_blank');
                productTagAnchor.classList.add('flits-link');
                productTagAnchor.textContent = item;
                if (index > 0) {
                    productTagSpan.append(document.createTextNode(','));
                }
                productTagSpan.append(productTagAnchor);
            });
            return {
                title: themeLang?.flits?.how_to_earn_credit_page.product_tag_credit_rule_title,
                description: themeLang?.flits?.how_to_earn_credit_page.product_tag_credit_rule_description.replace('{{ credit }}', (is_fixed) ?  MoneyFormat(credits/100) : `${credits/100}%`).replace('{{ tag }}', productTagSpan.innerHTML),
                icon: lanjson?.flits.icons.review_icon,
                linkTo: `/search?q=${avails[0]}`,
                linkBtntext: themeLang?.flits?.how_to_earn_credit_page.product_tag_btn_text,
                isEarned: false,
                moduleOn: module_on
            }
        case 'add_product_to_wishlist':
            return {
                title: themeLang?.flits?.how_to_earn_credit_page.wishlisted_product_credit_rule_title,
                description: themeLang?.flits?.how_to_earn_credit_page.wishlisted_product_credit_rule_description.replace('{{ credit }}',  MoneyFormat(credits/100)),
                icon: lanjson?.flits.icons.review_icon,
                linkTo: '/collections/all',
                linkBtntext: themeLang?.flits?.how_to_earn_credit_page.product_wishlist_btn_text,
                isEarned: false,
                moduleOn: module_on
            }
        case 'referrer_friend':
            return {
                title: themeLang?.flits?.refer_friend_page.referrer_credit_rule_title,
                description: themeLang?.flits?.refer_friend_page.referrer_credit_rule_description.replace('{{ credit }}',  MoneyFormat(credits/100)),
                icon: lanjson?.flits.icons.refer_icon,
                linkTo: '#flits-reward-page-refer-friend',
                linkBtntext: themeLang?.flits?.refer_friend_page.refer_btn_text,
                isEarned: false,
                moduleOn: module_on
            }
        case 'referee_friend':
            return {
                title: themeLang?.flits?.refer_friend_page.referrer_credit_rule_title,
                description: themeLang?.flits?.refer_friend_page.referrer_credit_rule_description.replace('{{ credit }}',  MoneyFormat(credits/100)),
                icon: lanjson?.flits.icons.refer_icon,
                linkTo: '#flits-reward-page-refer-friend',
                linkBtntext: themeLang?.flits?.refer_friend_page.refer_btn_text,
                isEarned: false,
                moduleOn: module_on
            }
        case 'referrals_total_number':
            return {
                title: themeLang?.flits?.refer_friend_page.credit_on_number_of_referrals_rule_title,
                description: themeLang?.flits?.refer_friend_page.credit_on_number_of_referrals_rule_description.replace('{{ credit }}',  MoneyFormat(credits/100)).replace('{{ referral_count }}', column_value),
                icon: lanjson?.flits.icons.refer_icon,
                linkTo: '#flits-reward-page-refer-friend',
                linkBtntext: themeLang?.flits?.refer_friend_page.refer_btn_text,
                isEarned: false,
                moduleOn: module_on
            }
        case 'referrals_total_spent':
            return {
                title: themeLang?.flits?.refer_friend_page.credit_on_referrals_total_spent_amount_rule_title,
                description: themeLang?.flits?.refer_friend_page.credit_on_referrals_total_spent_amount_rule_description.replace('{{ credit }}', (is_fixed) ?  MoneyFormat(credits/100) : `${credits/100}%`).replace('{{ total_spent_amount }}',  MoneyFormat(column_value)),
                icon: lanjson?.flits.icons.refer_icon,
                linkTo: '#flits-reward-page-refer-friend',
                linkBtntext: themeLang?.flits?.refer_friend_page.refer_btn_text,
                isEarned: false,
                moduleOn: module_on
            }
        case 'referrals_order_number':
            if(relation == '>='){
                return {
                    title: themeLang?.flits?.refer_friend_page.referrals_specific_order_and_next_orders_credit_rule_title.replace('{{ order_count }}', column_value),
                    description: themeLang?.flits?.refer_friend_page.referrals_specific_order_and_next_orders_credit_rule_description.replace('{{ credit }}', (is_fixed) ?MoneyFormat(credits/100) : `${credits/100}%`).replace('{{ order_count }}', column_value).replace('{{ order_count+1 }}', parseInt(column_value) + 1).replace('{{ order_count+2 }}', parseInt(column_value) + 2).replace('{{ order_count+n }}', 'n'),
                    icon: lanjson?.flits.icons.refer_icon,
                    linkTo: '#flits-reward-page-refer-friend',
                    linkBtntext: themeLang?.flits?.refer_friend_page.refer_btn_text,
                    isEarned: false,
                    moduleOn: module_on
                }
            }
            else{
                return {
                    title: themeLang?.flits?.refer_friend_page.referrals_specific_order_credit_rule_title,
                    description: themeLang?.flits?.refer_friend_page.referrals_specific_order_credit_rule_description.replace('{{ credit }}', (is_fixed) ? MoneyFormat(credits/100) : `${credits/100}%`).replace('{{ order_count }}', column_value),
                    icon: lanjson?.flits.icons.refer_icon,
                    linkTo: '#flits-reward-page-refer-friend',
                    linkBtntext: themeLang?.flits?.refer_friend_page.refer_btn_text,
                    isEarned: false,
                    moduleOn: module_on
                }
            }
        // Add more cases for other modules
        default:
            return null; // Handle unsupported module_on values
    }
  }
  function processEarningRules(){
    let earnRules = creditRules.rules.all_rules_data.filter(rule => rule.tab_to_append === "flits_earning_rules");
    let parentElement = document.querySelector('.flits-reward-page-earn-row');
    if (!parentElement) return; // Exit if the parent element doesn't exist
    if (earnRules.length === 0) {
        let emptyDom = document.querySelector('.flits-reward-page-empty-box');
        if(emptyDom){
          parentElement.innerHTML = '';
          let cloneEmpty = emptyDom.cloneNode(true);
          parentElement.appendChild(cloneEmpty);
        }
        return; // No rules found
    }
    else{
      let registerRule = earnRules.filter(rule => rule.module_on === "register");
      if(registerRule.length > 0){
        let creditOnRegisterDiv = document.querySelector('.flits-reward-page-how-it-step-one .flits-reward-page-how-it-box-info');
        if(creditOnRegisterDiv){
          creditOnRegisterDiv.innerHTML = lanjsonAdmin?.how_it_works.step1_description.replace('{{ credit }}', MoneyFormat(registerRule[0].credits/100));
        }
      }
      let result = earnRules.map(rule => {
          return getEarnRuleData(rule); // Generate earn rule data for each rule
      });
      // dispatch event for Earning rule modifeid object
      let flitsRewardPageEarnRule = new CustomEvent("flitsRewardPageEarnRule", {
        detail: {
          data: result
        }
      });
      window.dispatchEvent(flitsRewardPageEarnRule);
      let earningDom = document.querySelector('.flits-reward-page-earn-item');
      if (!earningDom) return; // Exit if the original element doesn't exist
      parentElement.innerHTML = '';

      // Static rule box for place order rule
      let staticItem = earningDom.cloneNode(true);
      staticItem.style.order = "0";
      staticItem.querySelector('.flits-reward-page-earn-title').innerHTML = "Points on order";
      staticItem.querySelector('.flits-reward-page-earn-info').innerHTML = "Earn points worth 5% order value";
      staticItem.querySelector('.flits-reward-page-earn-icon').innerHTML = "<svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'> <path d='M11.5 22.5H9.62182C7.27396 22.5 6.10003 22.5 5.28565 21.7945C4.47127 21.0889 4.27181 19.8991 3.87289 17.5194L2.66933 10.3398C2.48735 9.25428 2.39637 8.71152 2.68773 8.35576C2.9791 8 3.51461 8 4.58564 8H19.4144C20.4854 8 21.0209 8 21.3123 8.35576C21.6036 8.71152 21.5126 9.25428 21.3307 10.3398L21.0524 12' stroke='#252525' stroke-width='1.5' stroke-linecap='round'/> <path class='flits-widget-fill-storke-brand' d='M13.6418 14.9418C14.8486 14.2108 15.9018 14.5054 16.5345 14.9747C16.794 15.1671 16.9237 15.2633 17 15.2633C17.0763 15.2633 17.206 15.1671 17.4655 14.9747C18.0982 14.5054 19.1514 14.2108 20.3582 14.9418C21.9419 15.9013 22.3002 19.0666 18.6472 21.737C17.9514 22.2457 17.6035 22.5 17 22.5C16.3965 22.5 16.0486 22.2457 15.3528 21.737C11.6998 19.0666 12.0581 15.9013 13.6418 14.9418Z' fill='#000654' stroke='#000654' stroke-width='1.5' stroke-linecap='round'/> <path d='M17.5 8C17.5 4.96243 15.0376 2.5 12 2.5C8.96243 2.5 6.5 4.96243 6.5 8' stroke='#252525' stroke-width='1.5'/> </svg>";
      let linkElement = staticItem.querySelector('.flits-reward-page-earn-redirect a');
      if(linkElement){linkElement.href = "/collections/all"}
      parentElement.appendChild(staticItem);

      result.map(rule => {
        let clonedItem = earningDom.cloneNode(true); // Clone deeply (includes children)
        clonedItem.querySelector('.flits-reward-page-earn-title').innerHTML = rule.title;
        clonedItem.querySelector('.flits-reward-page-earn-info').innerHTML = rule.description;
        if(rule.icon.type = "code"){
         clonedItem.querySelector('.flits-reward-page-earn-icon').innerHTML = rule.icon.code; 
        }
        else{
          clonedItem.querySelector('.flits-reward-page-earn-icon img').src = rule.icon.url;
        }
        let linkElement = clonedItem.querySelector('.flits-reward-page-earn-redirect a');
        if(linkElement){
          linkElement.href = rule.linkTo;
        }
        if(rule.isEarned){clonedItem.setAttribute("earned", "true")};
        if(rule.moduleOn){clonedItem.setAttribute("module", rule.moduleOn)}
        if (rule.moduleOn === "register") {
          clonedItem.style.order = "-2"
        }else if(rule.moduleOn === "subscribe"){
          clonedItem.style.order = "-1"
        }
        parentElement.appendChild(clonedItem);
      })

      // Static rule box for receiver earn credit rule
      // let staticItem2 = earningDom.cloneNode(true);
      // staticItem2.style.order = "0";
      // staticItem2.querySelector('.flits-reward-page-earn-title').innerHTML = "Receiver's registration";
      // staticItem2.querySelector('.flits-reward-page-earn-info').innerHTML = "Receiver will earn 100 credits";
      // staticItem2.querySelector('.flits-reward-page-earn-icon').innerHTML = "<svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'> <path d='M11.5 22.5H9.62182C7.27396 22.5 6.10003 22.5 5.28565 21.7945C4.47127 21.0889 4.27181 19.8991 3.87289 17.5194L2.66933 10.3398C2.48735 9.25428 2.39637 8.71152 2.68773 8.35576C2.9791 8 3.51461 8 4.58564 8H19.4144C20.4854 8 21.0209 8 21.3123 8.35576C21.6036 8.71152 21.5126 9.25428 21.3307 10.3398L21.0524 12' stroke='#252525' stroke-width='1.5' stroke-linecap='round'/> <path class='flits-widget-fill-storke-brand' d='M13.6418 14.9418C14.8486 14.2108 15.9018 14.5054 16.5345 14.9747C16.794 15.1671 16.9237 15.2633 17 15.2633C17.0763 15.2633 17.206 15.1671 17.4655 14.9747C18.0982 14.5054 19.1514 14.2108 20.3582 14.9418C21.9419 15.9013 22.3002 19.0666 18.6472 21.737C17.9514 22.2457 17.6035 22.5 17 22.5C16.3965 22.5 16.0486 22.2457 15.3528 21.737C11.6998 19.0666 12.0581 15.9013 13.6418 14.9418Z' fill='#000654' stroke='#000654' stroke-width='1.5' stroke-linecap='round'/> <path d='M17.5 8C17.5 4.96243 15.0376 2.5 12 2.5C8.96243 2.5 6.5 4.96243 6.5 8' stroke='#252525' stroke-width='1.5'/> </svg>";
      // linkElement = staticItem2.querySelector('.flits-reward-page-earn-redirect a');
      // if(linkElement){linkElement.href = "#flits-reward-page-refer-friend"}
      // parentElement.appendChild(staticItem2);
    }
  }

  // processing spent rule
  function processSpentRules() {
    let spentRules = creditRules.rules.all_rules_data.filter(rule => rule.tab_to_append === "flits_spent_rules");
    let parentElement = document.querySelector('.flits-reward-page-redeem-row');
    if (!parentElement) return; // Exit if the parent element doesn't exist
    if (spentRules.length === 0) {
      let emptyDom = document.querySelector('.flits-reward-page-empty-box');
      if(emptyDom){
        parentElement.innerHTML = '';
        let cloneEmpty = emptyDom.cloneNode(true);
        parentElement.appendChild(cloneEmpty);
      }
      return;
    }
    let result = spentRules.map(rule => {
        let cartRangeMsg = "";
        let creditMsg = "";
        let icon = "";
        let [min, max] = rule.column_value.split(':').map(value => parseInt(value));
        let fixedCredit = rule.is_fixed === 1 ? rule.credits / 100 : rule.credits / 100;
        let cart_range_text_max = themeLang?.flits?.how_to_spend_credit_page?.spend_credit_on_cart_rule_description_3.split('.');
        let cart_range_text = themeLang?.flits?.how_to_spend_credit_page?.spend_credit_on_cart_rule_description_2.split('.');
       
        if (max === -1) {
            cartRangeMsg = cart_range_text_max[0].replace('{{ min_cart_value }}', MoneyFormat(min));
        } else {
            cartRangeMsg = cart_range_text[0].replace('{{ min_cart_value }}', MoneyFormat(min)).replace('{{ max_cart_value }}', MoneyFormat(max));
        }
        if (rule.is_fixed === 1) {
            icon = lang.flits.icons.redeem_fixed_icon;
            creditMsg = cart_range_text_max[1].replace('{{ credit }}', MoneyFormat(fixedCredit));
        } else {
            icon = lang.flits.icons.redeem_percentage_icon;
            creditMsg = cart_range_text[1].replace('{{ credit }}', `${fixedCredit}%`);
        }
        return { title: creditMsg, description: cartRangeMsg, icon: icon };
    });
    // dispatch event for spent rule modified object
    let flitsRewardPageSpentRule = new CustomEvent("flitsRewardPageSpentRule", {
        detail: {
          data: result
        }
      });
    window.dispatchEvent(flitsRewardPageSpentRule);
    let earningDom = document.querySelector('.flits-reward-page-redeem-item');
    if (!earningDom) return; // Exit if the original element doesn't exist
    parentElement.innerHTML = '';
    result.map(rule => {
      let clonedItem = earningDom.cloneNode(true); // Clone deeply (includes children)
      clonedItem.querySelector('.flits-reward-page-redeem-title').innerHTML = rule.title;
      clonedItem.querySelector('.flits-reward-page-redeem-info').innerHTML = rule.description;
      if(rule.icon.type = "code"){
       let newRedeenIcon = clonedItem.querySelector('.flits-reward-page-redeem-icon');
       if(newRedeenIcon){
         newRedeenIcon.innerHTML = rule.icon.code;
       }
      }
      else{
        clonedItem.querySelector('.flits-reward-page-redeem-icon img').src = rule.icon.url;
      }
      parentElement.appendChild(clonedItem);
    })
  }

  // copy refer link btn
  let copyLinkBtn = document.querySelector(".flits-reward-page-link-copy-btn");
  if(copyLinkBtn){
    copyLinkBtn.addEventListener("click", function(e){
      var input = e.target.parentNode.querySelector('input[name="flits_reward_page_referral_link"]');
      input.select();
      document.execCommand('copy');
      var svgIcon = '<svg class="flits-widget-tick-svg" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1.16663 7.16669L4.08329 10.0834L12.8333 0.916687" /> </svg>';
      e.target.innerHTML = svgIcon;
      setTimeout(function() {
          e.target.textContent = 'Copy';
      }, 3500);
    });
  }
  //email share click
  window.flitsRewardPageEmailShare = function(){
    let subject = 'Refer And earn'
    let encodedDescription = encodeURIComponent(unescape(referInvitationText));
    let mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(encodedDescription)}`;
    window.location.href = mailtoLink;
  }
  // fb share click
  window.flitsRewardPageFBShare = function(){
    let url = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(unescape(customerReferLink)) + "&quote=" + referInvitationText;
    window.open(url);
  }
  // navigator share click
  window.flitsRewardPageNavigatorShare = function(){
    let data = {
        title: 'Refer Freind',
        text: referInvitationText
    };
    if (navigator.share && navigator.canShare(data)) {
        navigator.share(data)
    } else {
        alert(`Navigator share is not supported by your browser. ${referInvitationText}`)
    }
  }
  // wp share click
  window.flitsRewardPageWPShare = function(){
    let encodedDescription = encodeURIComponent(unescape(referInvitationText));
    let url = "https://api.whatsapp.com/send?text=" + encodedDescription;
    window.open(url);
  }

  // general subscription ajax call
  async function generalSubscriptionSave() {
    try{
      let formdata = new FormData();
      formdata.append("token", window.flitsRewardPageObjects.token);
      formdata.append("customer_hash", window.flitsRewardPageObjects.customerHash);
      formdata.append("accepts_marketing", true);
      formdata.append("credit_subject", 'subscribe');
      let requestOptions = {
          method: 'POST',
          redirect: 'follow',
          body: formdata
      };
      let result = await fetch(`${window.location.origin}${window.flitsRewardPageObjects?.base_url}/${window.flitsRewardPageObjects.customerId}/general_subscription_save`, requestOptions)
      let resultJson = await result.json();
      return resultJson;
    }catch (error) {
      return null;
    }
  }
  function subscriberEarnClickDispatch(){
    let subscriberEarnClick = document.querySelector('.flits-reward-page-earn-item[module="subscribe"]:not([earned="true"]) .flits-reward-page-earn-redirect a');
    if (subscriberEarnClick) {
      subscriberEarnClick.addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        let parentElement = event.target.closest('.flits-reward-page-earn-item');
        if (parentElement) {
            parentElement.setAttribute("earned", "true")
        }
        let snackBarDom = document.querySelector('.flits-reward-page-static-sidebar');
        snackBarDom.innerHTML = themeLang?.flits?.how_to_earn_credit_page?.subscribing_email;
        snackBarDom.classList.add('active');
        let subscriptionSave = await generalSubscriptionSave();
        if(subscriptionSave.status === true){
            snackBarDom.innerHTML = themeLang?.flits?.how_to_earn_credit_page?.subscribed_successfully
        }
        else{
            snackBarDom.innerHTML = themeLang?.flits?.general?.something_went_wrong;
        }
        setTimeout(function() {
          snackBarDom.classList.remove('active');
          snackBarDom.innerHTML = '';
        }, 3500);
      });
    }
  }

  //hideLoader
  function hideLoader(){
    let loaderDom = document.querySelector(".flits-reward-page-loader-wrap");
    if(loaderDom){
      loaderDom.classList.remove('active');
    }
  }

  function commonLangUpdate(){
    // hero banner section
    let heroHeader = document.querySelector('.flits-reward-page-hero-banner .flits-reward-page-header');
    let heroSubHeader = document.querySelector('.flits-reward-page-hero-banner .flits-reward-page-sub-header');
    let heroShopNowBtn =  document.querySelector('.flits-reward-page-hero-banner .flits-hero-banner-shop-now-btn');
    let heroLoginBtn =  document.querySelector('.flits-reward-page-hero-banner .flits-signin-btn');
    let heroRegisterBtn =  document.querySelector('.flits-reward-page-hero-banner .flits-signup-btn');
    let heroImage = document.querySelector('.flits-reward-page-hero-banner .flits-reward-page-banner-image img');
    // how it works section
    let howitHeader = document.querySelector('.flits-reward-page-how-it .flits-reward-page-header');
    let howitSubHeader = document.querySelector('.flits-reward-page-how-it .flits-reward-page-sub-header');
    let stepOneTitle = document.querySelector('.flits-reward-page-how-it-step-one .flits-reward-page-how-it-box-title');
    let stepOneInfo = document.querySelector('.flits-reward-page-how-it-step-one .flits-reward-page-how-it-box-info');
    let stepTwoTitle = document.querySelector('.flits-reward-page-how-it-step-two .flits-reward-page-how-it-box-title');
    let stepTwoInfo = document.querySelector('.flits-reward-page-how-it-step-two .flits-reward-page-how-it-box-info');
    let stepThreeTitle = document.querySelector('.flits-reward-page-how-it-step-three .flits-reward-page-how-it-box-title');
    let stepThreeInfo = document.querySelector('.flits-reward-page-how-it-step-three .flits-reward-page-how-it-box-info');
    // ways to earn
    let earnTitle = document.querySelector('.flits-reward-page-ways-to-earn .flits-reward-page-header');
    let earnSubHeader = document.querySelector('.flits-reward-page-ways-to-earn .flits-reward-page-sub-header');
    // ways to redeem
    let redeemTitle = document.querySelector('.flits-reward-page-ways-to-redeem .flits-reward-page-header');
    let redeemSubHeader = document.querySelector('.flits-reward-page-ways-to-redeem .flits-reward-page-sub-header');
    // refer section
    let referTitle = document.querySelector('.flits-reward-page-refer-friend .flits-reward-page-header');
    let referSubHeader = document.querySelector('.flits-reward-page-refer-friend .flits-reward-page-sub-header');
    let referShareLinkText = document.querySelector('.flits-reward-page-social-share-wrap .flits-reward-page-social-share-text');
    let referCopyBtnText = document.querySelector('.flits-reward-page-link-copy-btn');
    let referLoginBtn = document.querySelector('.flits-reward-page-refer-friend .flits-signin-btn');
    let referRegisterBtn = document.querySelector('.flits-reward-page-refer-friend .flits-signup-btn');
    let referBgImage = document.querySelector('.flits-reward-page-refer-friend .flits-reward-page-banner-image img');
    // empty box
    let emptyTitle = document.querySelector('.flits-reward-page-empty-content .flits-reward-page-header');
    let emptySubHeader = document.querySelector('.flits-reward-page-empty-content .flits-reward-page-sub-header');
    let emptyButton = document.querySelector('.flits-reward-page-empty-content a');
    
    
     if(window.flitsRewardPageObjects?.customer){
      if(heroHeader && lanjsonAdmin.banner?.member_title) heroHeader.innerHTML = lanjsonAdmin.banner.member_title.replace("{{ customer }}", window.flitsRewardPageObjects?.customerFName);
      if(heroShopNowBtn && lanjsonAdmin.banner?.member_button1_title) heroShopNowBtn.innerHTML = lanjsonAdmin.banner.member_button1_title;
      if(heroShopNowBtn && lanjsonAdmin.banner?.member_button1_url) heroShopNowBtn.href =  lanjsonAdmin.banner?.member_button1_url;
      if(heroSubHeader) heroSubHeader.innerHTML = lanjsonAdmin.banner.member_description;
      //if(howitSubHeader) howitSubHeader.innerHTML = lanjsonAdmin.how_it_works.sub_header_customer;
      if(referTitle && lanjsonAdmin.refer_friend?.member_title) referTitle.innerHTML = lanjsonAdmin.refer_friend.member_title;
      if(referSubHeader && lanjsonAdmin.refer_friend?.member_description) referSubHeader.innerHTML = lanjsonAdmin.refer_friend.member_description;
      if(referShareLinkText && themeLang?.flits?.refer_friend_page.share_referral_link_title) referShareLinkText.innerHTML = themeLang?.flits?.refer_friend_page.share_referral_link_title;
      if(referCopyBtnText && lanjsonAdmin.refer_friend?.member_button1_title) referCopyBtnText.innerHTML = lanjsonAdmin.refer_friend.member_button1_title;
      //if(stepThreeInfo) stepThreeInfo.innerHTML = lanjsonAdmin.how_it_works.step_three_info;
    }
    else{
      if(heroHeader) heroHeader.innerHTML = lanjsonAdmin.banner.guest_title;
      if(heroSubHeader) heroSubHeader.innerHTML = lanjsonAdmin.banner.guest_description;
      if(heroLoginBtn) heroLoginBtn.innerHTML = lanjsonAdmin.banner.guest_button2_title;
      if(heroLoginBtn && lanjsonAdmin.banner?.guest_button2_url) heroLoginBtn.href =  lanjsonAdmin.banner?.guest_button2_url;
      if(heroRegisterBtn) heroRegisterBtn.innerHTML = lanjsonAdmin.banner.guest_button1_title;
      if(heroRegisterBtn && lanjsonAdmin.banner?.guest_button1_url) heroRegisterBtn.href =  lanjsonAdmin.banner?.guest_button1_url;
      if(referTitle) referTitle.innerHTML = lanjsonAdmin.refer_friend.guest_title;
      if(referSubHeader) referSubHeader.innerHTML = lanjsonAdmin.refer_friend.guest_description;
      if(referLoginBtn) referLoginBtn.innerHTML = lanjsonAdmin.refer_friend.guest_button2_title;
      if(referLoginBtn && lanjsonAdmin.refer_friend?.guest_button2_url) referLoginBtn.href =  lanjsonAdmin.refer_friend?.guest_button2_url;
      if(referRegisterBtn) referRegisterBtn.innerHTML = lanjsonAdmin.refer_friend.guest_button1_title;
      if(referRegisterBtn && lanjsonAdmin.refer_friend?.guest_button1_url) referRegisterBtn.href =  lanjsonAdmin.refer_friend?.guest_button1_url;
      //if(stepThreeInfo) stepThreeInfo.innerHTML = lanjsonAdmin.how_it_works.step_three_info_customer;
    }
    
    if(heroImage && lanjsonAdmin.banner.image) heroImage.src = lanjsonAdmin.banner.image;
    if(referBgImage && lanjsonAdmin.refer_friend.image) referBgImage.src = lanjsonAdmin.refer_friend.image;
    if(howitHeader) howitHeader.innerHTML = lanjsonAdmin.how_it_works.title;
    if(howitSubHeader) howitSubHeader.innerHTML = lanjsonAdmin.how_it_works.description;
    if(stepOneTitle) stepOneTitle.innerHTML = lanjsonAdmin.how_it_works.step1_title;
    if(stepOneInfo) stepOneInfo.innerHTML = lanjsonAdmin.how_it_works.step1_description;
    if(stepTwoTitle) stepTwoTitle.innerHTML = lanjsonAdmin.how_it_works.step2_title;
    if(stepTwoInfo) stepTwoInfo.innerHTML = lanjsonAdmin.how_it_works.step2_description;
    if(stepThreeTitle) stepThreeTitle.innerHTML = lanjsonAdmin.how_it_works.step3_title;
    if(stepThreeInfo) stepThreeInfo.innerHTML = lanjsonAdmin.how_it_works.step3_description;
    if(earnTitle) earnTitle.innerHTML = lanjsonAdmin.how_to_earn.title;
    if(earnSubHeader) earnSubHeader.innerHTML = lanjsonAdmin.how_to_earn.description;
    if(redeemTitle) redeemTitle.innerHTML = lanjsonAdmin.how_to_redeem.title;
    if(redeemSubHeader) redeemSubHeader.innerHTML = lanjsonAdmin.how_to_redeem.description;
    if(emptyTitle) emptyTitle.innerHTML = themeLang?.flits?.how_to_earn_credit_page.no_rule_found;
    if(emptyButton) emptyButton.innerHTML = themeLang?.flits?.buttons.shop_now;
  }

  // moneyFormat functions
  function unescapeHtml(value) {
    return value
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#039;/g, "'")
      .replace(/&#39;/g, "'");
        
  }
  function formatMoney(cents, format, replaceObject) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    let formatString = format || "${{amount}}";
  
    function defaultOption(opt, def) {
      return typeof opt === "undefined" ? def : opt;
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
      if (isNaN(number) || number == null) {
        return "0";
      }
      number = (number / 100.0).toFixed(precision);
      let parts = number.split(".");
      let dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      let cents = parts[1] ? decimal + parts[1] : "";
      return dollars + cents;
    }
  
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      default:
    }
  
    return unescapeHtml(
      formatString.replace(
        placeholderRegex,
        value
      )
    );
  }
  // function MoneyFormat(price) {
  //   let negativeOrNot = parseFloat(price) < 0 ? true : false
  //   let htmlData = negativeOrNot ? formatMoney(
  //     price * 100,
  //     window?.flitsRewardPageObjects?.moneyFormat?.replace('Rs. ', '')
  //   ) : formatMoney(
  //     Math.abs(price * 100),
  //     window?.flitsRewardPageObjects?.moneyFormat?.replace('Rs. ', '')

  //   )
  //   return (
  //     htmlData
  //   )
  // }
  function MoneyFormat(price) {
    const isNegative = parseFloat(price) < 0;

    let formattedPrice = formatMoney(
        Math.abs(price * 100),
        // window?.flitsRewardPageObjects?.moneyFormat
        window?.flitsRewardPageObjects?.moneyFormat?.replace('Rs. ', '')
    );
    if (formattedPrice.includes('.00')) {
        formattedPrice = formattedPrice.replace(/\.00$/, '');
    }

    return isNegative ? `-${formattedPrice}` : formattedPrice;
  }
  // color functions
  function getContrastingColor(hexColor) {
    // Ensure hex format is standardized
    if (hexColor.startsWith("#")) {
      hexColor = hexColor.slice(1);
    }
  
    // Expand shorthand form (e.g., "03F" -> "0033FF")
    if (hexColor.length === 3) {
      hexColor = hexColor.split("").map(c => c + c).join("");
    }
  
    // Convert hex color to RGB values
    const r = parseInt(hexColor.substring(0, 2), 16);
    const g = parseInt(hexColor.substring(2, 4), 16);
    const b = parseInt(hexColor.substring(4, 6), 16);
  
    // Calculate relative luminance of the color
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  
    // Check if the color is dark or light
    const isDark = luminance < 128;
  
    // Return contrasting color
    return isDark ? "#FFFFFF" : "#000000"; // Light for dark colors, dark for light colors
  }
  function loadStyleScript(url) {
    let isCss = url.indexOf('.css') != -1;
    let tag = isCss ? document.createElement("link") : document.createElement("script");
    tag.type = isCss ? "text/css" : "text/javascript";
    isCss && (tag.rel = "stylesheet");
    isCss && (tag.href = url);
    !isCss && (tag.src = url);
    document.getElementsByTagName("head")[0].appendChild(tag);
    return new Promise((res, rej) => {
        tag.onload = function() {
          res();
        }
        tag.onerror = function () {
          rej();
        }
    });
  }
}